/**
 * Content-type gate for the notification overlay: only notification types in
 * this allowlist are ever eligible to be surfaced through the overlay.
 * Fail-closed by design — a `notificationType` not listed here never shows,
 * even if it would otherwise be a perfectly reasonable candidate. This is
 * deliberately conservative: it exists to keep informational/marketing
 * content ("Deals and Recommendations"-style notices, or anything from the
 * separate Braze marketing in-app-messaging system) from ever reaching this
 * high-urgency, interrupt-style surface.
 *
 * The starter set below covers the clearest, least ambiguous
 * transactional/product events available in the known notification-type
 * registry (notificationTypeLabels.ts in fe-core) at the time this gate was
 * written: a decisive auction outcome and order-shipping milestones. It is
 * NOT a comprehensive, business-approved list of every notice that should
 * ever interrupt a buyer — that requires product/design sign-off (tracked
 * under the Notification Center epic's design-reconciliation follow-up) and
 * should be revisited before this surface is wired up to real traffic.
 */
export const OVERLAY_ELIGIBLE_NOTIFICATION_TYPES: ReadonlySet<string> = new Set(
  ['BID_WON', 'WON_LISTING', 'ORDER_SHIPPED', 'SHIPMENT_DELIVERED']
)

export const isOverlayEligibleNotificationType = (
  notificationType: string
): boolean => OVERLAY_ELIGIBLE_NOTIFICATION_TYPES.has(notificationType)
